{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/PACSLAC-D",
	"name": "PACSLAC-D",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "PACSLAC-D",
	"purpose": "Verkorte pijnbeoordelingslijst voor ouderen met beperkte communicatiemogelijkheden",
	"description": "De PACSLAC bestaat uit een dichotoom scoringssysteem (0 staat voor geen pijn; 1 staat voor pijn) en wordt gescoord als het gedrag aanwezig is.",
	"item": [
		{
			"linkId": "70100",
			"text": "Gelaat",
			"type": "group",
			"item": [
				{
					"linkId": "70200",
					"text": "Uitdrukking van pijn",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70201",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70202",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70300",
					"text": "Een specifiek geluid of uiting van pijn 'au' of 'oef'",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70301",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70302",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70400",
					"text": "Wenkbrauwen fronsen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70401",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70402",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70500",
					"text": "Grimas",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70501",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70502",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70600",
					"text": "Rimpels in het voorhoofd",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70601",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70602",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70700",
					"text": "Kreunen en kermen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70701",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70702",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70800",
					"text": "Verandering in de ogen (scheel kijken, mat, helder, meer bewegingen)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70801",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70802",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70900",
					"text": "Pijnlijke plek aanraken en vasthouden",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70901",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70902",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71000",
					"text": "Pijnlijke plek beschermen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71001",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71002",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71100",
					"text": "Terugtrekken",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71101",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71102",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "71200",
			"text": "Verzet/afweer",
			"type": "group",
			"item": [
				{
					"linkId": "71300",
					"text": "Verbale agressie",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71301",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71302",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71400",
					"text": "Fysieke agressie (bijv. mensen en/of voorwerpen wegduwen, anderen krabben, anderen slaan, stompen, schoppen)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71401",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71402",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71500",
					"text": "Geërgerd (geagiteerd)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71501",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71502",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71600",
					"text": "Achteruitdeinzen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71601",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71602",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71700",
					"text": "Niet aangeraakt willen worden",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71701",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71702",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71800",
					"text": "Niet-coöperatief/weerstand tegen zorgverlening",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71801",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71802",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "71900",
			"text": "Sociaal emotioneel/stemming",
			"type": "group",
			"item": [
				{
					"linkId": "72000",
					"text": "Nors/prikkelbaar",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72001",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72002",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72100",
					"text": "Schreeuwen/krijsen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72101",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72102",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72200",
					"text": "Donkere blik",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72201",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72202",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72300",
					"text": "Verdrietige blik",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72301",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72302",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72400",
					"text": "Geen mensen in de buurt laten komen",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72401",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72402",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72500",
					"text": "Ontsteld (ontdaan)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72501",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72502",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72600",
					"text": "Blozend, rood gelaat",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72601",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72602",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72700",
					"text": "Rusteloos",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72701",
								"display": "Ja"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72702",
								"display": "Nee"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		}
	]
}
